import { ResumesTemplateEnum } from '@gql/graphql'

export const proTemplates: ResumesTemplateEnum[] = [
  ResumesTemplateEnum.Neue,
  ResumesTemplateEnum.Oxford,
  ResumesTemplateEnum.Bauhaus,
]
